import axios from 'axios';

export const getTipsterPreferences = (tipsterID: string) =>
  axios.get(`/v1/tipsters/${tipsterID}/preferences`);
